import React from 'react';
import { Text } from '@usewaypoint/block-text';
import type { TextProps } from '@usewaypoint/block-text';
import { convertEmailPillsToBrackets, convertVariablesToPlaceholders } from '../../../../../constants/variablePlaceholders';

/**
 * Custom Text component that renders {{variables}} as styled placeholders
 * in the email canvas preview
 */
export default function TextWithPlaceholders(props: TextProps) {
  // Get the text content
  const text = props.props?.text || '';

  // Step 1: Convert HTML pill spans to {{variables}}
  const textWithBrackets = convertEmailPillsToBrackets(text);

  // Step 2: Convert {{variables}} to styled placeholder HTML
  const textWithPlaceholders = convertVariablesToPlaceholders(textWithBrackets);

  // Return modified props with placeholder HTML
  const modifiedProps: TextProps = {
    ...props,
    props: {
      ...props.props,
      text: textWithPlaceholders,
      markdown: true, // Enable markdown rendering so HTML placeholders are rendered, not escaped
    },
  };

  return <Text {...modifiedProps} />;
}
